import React from 'react';
import Product from './DcProduct';

const ProductReplace = ({
  itemToReplace,
  currentCategory,
  props,
  handleRemoveItem,
}) => {
  return (
    <main className="selectedcatcontainer">
      <div className="dc-product-replace">
        <p>
          You already have a{' '}
          {itemToReplace.variants[0].categoryName != undefined
            ? itemToReplace.variants[0].categoryName.split('__')[2]
            : itemToReplace.variants[0].categoryCurrent}{' '}
          in your outfit:{' '}
          <strong>{itemToReplace.variants[0].variantName}</strong>
        </p>
        <Product
          key={itemToReplace.product}
          productId={itemToReplace.product}
          addButtonTitle="Remove"
          data={itemToReplace}
          sourceMerchantProductSku={props.merchantProductSku}
          sourceCompatioCategoryId={props.categoryId}
          categoryPosition={props.categoryPosition + 1}
          productName={props.productName}
          isReel={currentCategory === 'Fly Reels' ? true : false}
          currentCategory={currentCategory}
          isAlreaydAdded
          handleRemoveItem={handleRemoveItem}
        />
      </div>
    </main>
  );
};

export default ProductReplace;
